// Packages
import React from "react";
import { inject, observer } from "mobx-react";
import CaptureLifeApi from "../../modules/CaptureLifeApi";
// Components
import { Card, WingBlank } from "antd-mobile";

@inject("store")
@observer
class ListEvents extends React.Component {
    state = {
        jobs: null,
        settings: null,
        loading: true,
    };

    constructor(props) {
        super(props);
    }

    getAccountId() {
        return this.props.match.params.id;
    }

    async componentDidMount() {
        let api = new CaptureLifeApi(
            process.env.REACT_APP_PRE_SIGNUP_CLIENT_TOKEN
        );
        let accountId = this.getAccountId();

        this.setState({
            settings: await api.getAccountSetting(accountId),
            loading: false,
        });
    }

    getCompanyName() {
        if (this.state.settings && this.state.settings.name) {
            return (
                <>
                    WELCOME TO
                    <br />
                    {this.state.settings.name.toUpperCase()}
                    <br /><br />
                    <div className = "red">{this.state.settings.note}</div>
                </>
            );
        }
    }
    getContactInfomation() {
        if (!this.state.settings) return;

        let settings = this.state.settings;

        if (!settings) return;

        if (settings.isShowPhone() && settings.isShowEmail()) {
            return (
                <>
                    <a href={"tel:" + this.state.settings.phone}>
                        {this.state.settings.phone}
                    </a>{" "}
                    |{" "}
                    <a href={"mailto:" + this.state.settings.email}>
                        {this.state.settings.email}
                    </a>
                    {this.state.settings.sample ?
                        <> 
                            {" | "}
                            <a href={"http://" + this.state.settings.sample} target = "_blank">
                                {"View Samples"}
                            </a>
                        </>
                        : ''
                    }
                </>
            );
        }
        if (settings.isShowEmail()) {
            return (
                <>
                    <a href={"mailto:" + this.state.settings.email}>
                        {this.state.settings.email}
                    </a>
                    {this.state.settings.sample ?
                        <> 
                            {" | "}
                            <a href={"http://" + this.state.settings.sample} target = "_blank">
                                {"View Samples"}
                            </a>
                        </>
                        : ''
                    }
                </>
            );
        }
        if (settings.isShowPhone()) {
            return (
                <>
                    <a href={"tel:" + this.state.settings.phone}>
                        {this.state.settings.phone}
                    </a>
                    {this.state.settings.sample ?
                        <> 
                            {" | "}
                            <a href={"http://" + this.state.settings.sample} target = "_blank">
                                {"View Samples"}
                            </a>
                        </>
                        : ''
                    }
                </>
            );
        }
    }

    render() {
        return (
            <>
                <div className="container">
                    <WingBlank>
                        <h3 style={{ textAlign: "center" }}>
                            {this.getCompanyName()}
                        </h3>
                        <p style={{ textAlign: "center" }}>
                            {this.getContactInfomation()}
                        </p>
                    </WingBlank>

                    <Card className="job-card">
                        <Card.Body
                            style={{
                                textAlign: "center",
                                fontSize: "18px",
                                lineHeight: "1.6",
                                padding: "24px",
                            }}
                        >
                            <p style={{ margin: 0 }}>
                                Great things are coming!
                            </p>
                            <p style={{ margin: "12px 0 0 0" }}>
                                Photo preregistration is briefly paused while we
                                make improvements to your experience.
                                <br />
                                We'll be back open Monday evening (12/15).
                            </p>
                        </Card.Body>
                    </Card>
                </div>
            </>
        );
    }
}

export default ListEvents;
